"use strict";
exports.__esModule = true;
exports.isCounty = exports.isCity = exports.isAddressLine2 = exports.isAddressLine = void 0;
var addressLinePattern = "^[0-9a-z\\.'\\-\\,\\s]*$";
var addressLine2Pattern = "^[0-9a-z\\.'\\-\\,&\\s]*$";
var latinCharsDashAposDotSpacePattern = "^[a-z\\.'\\-\\s]+$";
var latinCharsDashAposDotSpaceAllowEmptyPattern = "^[a-z\\.'\\-\\s]*$";
var validAddressLineExpression = new RegExp(addressLinePattern, 'gi');
var validAddressLine2Expression = new RegExp(addressLine2Pattern, 'gi');
var validAddressExpression = new RegExp(latinCharsDashAposDotSpacePattern, 'gi');
var validAddressExpressionAllowEmpty = new RegExp(latinCharsDashAposDotSpaceAllowEmptyPattern, 'gi');
function isAddressLine(value) {
    return value.match(validAddressLineExpression) !== null;
}
exports.isAddressLine = isAddressLine;
function isAddressLine2(value) {
    return value.match(validAddressLine2Expression) !== null;
}
exports.isAddressLine2 = isAddressLine2;
function isCity(value) {
    return value.match(validAddressExpression) !== null;
}
exports.isCity = isCity;
function isCounty(value) {
    return value.match(validAddressExpressionAllowEmpty) !== null;
}
exports.isCounty = isCounty;
//# sourceMappingURL=address.js.map